// Scoring + combo system. Pure logic over RunState — fully unit-testable.
// Formulas from js/game3d.js:1021-1059 and COMBO_CONFIG (js/constants.js:645).

import { COMBO_TIERS, COMBO_DECAY_TIME } from '@/config/tuning';
import type { RunState } from '@/app/context';
import type { EventBus } from '@/app/events';

export function addScore(run: RunState, bus: EventBus, points: number, label?: string): number {
  const awarded = Math.round(points * run.comboMultiplier * run.powerUpScoreMultiplier);
  run.score += awarded;
  const payload: { points: number; total: number; label?: string } = {
    points: awarded,
    total: run.score,
  };
  if (label !== undefined) payload.label = label;
  bus.emit('score:awarded', payload);
  return awarded;
}

export function incrementCombo(run: RunState, bus: EventBus): void {
  run.combo += 1;
  run.comboDecayTimer = 0;
  let multiplier = 1.0;
  for (const tier of COMBO_TIERS) {
    if (run.combo >= tier.threshold) multiplier = tier.multiplier;
  }
  run.comboMultiplier = multiplier;
  bus.emit('combo:changed', { combo: run.combo, multiplier });
}

export function resetCombo(run: RunState, bus: EventBus): void {
  run.combo = 0;
  run.comboMultiplier = 1.0;
  run.comboDecayTimer = 0;
  bus.emit('combo:changed', { combo: 0, multiplier: 1.0 });
}

export function updateComboDecay(run: RunState, bus: EventBus, dt: number): void {
  if (run.combo <= 0) return;
  run.comboDecayTimer += dt;
  if (run.comboDecayTimer >= COMBO_DECAY_TIME) {
    resetCombo(run, bus);
  }
}
